import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function TrueLove() {
  const alien1 = useRef();
  const alien2 = useRef();
  const mouth1 = useRef();
  const pupil1 = useRef();
  const mouth2 = useRef();
  const pupil2 = useRef();
  const rightArm = useRef();
  const leftArm = useRef();
  const heart = useRef();

  useEffect(() => {
    gsap.to(heart.current, {
      x: "-15",
      y: "15",
      yoyo: "true",
      duration: "1.5",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(alien1.current, {
      y: "30",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(alien2.current, {
      y: "30",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(mouth1.current, {
      scale: "1.2",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil1.current, {
      rotation: "45",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(mouth2.current, {
      scale: "1.2",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil2.current, {
      rotation: "45",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(rightArm.current, {
      y: "10",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(leftArm.current, {
      y: "10",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
  });

  return (
    <>
      <svg
        width="300"
        height="300"
        viewBox="0 0 888 476"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="trueLove"
      >
        <g id="undraw_true_love_cy8x 1" clipPath="url(#clip0_0_1)">
          <path
            id="Vector"
            d="M252.096 8.12274L249.796 6.9689L243.566 19.3876L245.865 20.5414L252.096 8.12274Z"
            fill="white"
          />
          <path
            id="Heart"
            d="M270.985 36.4774C258.607 24.1 241.82 17.1464 224.315 17.1464C206.811 17.1464 190.024 24.1 177.646 36.4774L177.629 36.4952C165.194 24.4247 148.51 17.7307 131.18 17.8594C113.851 17.9882 97.2682 24.9293 85.0142 37.1833C72.7603 49.4373 65.8191 66.0202 65.6904 83.3495C65.5617 100.679 72.2557 117.363 84.3262 129.798L84.3084 129.815L177.646 223.154L270.985 129.815C277.113 123.687 281.975 116.411 285.292 108.404C288.608 100.396 290.316 91.8137 290.316 83.1464C290.316 74.4792 288.608 65.8968 285.292 57.8893C281.975 49.8818 277.113 42.606 270.985 36.4774V36.4774Z"
            fill="#FF6584"
            ref={heart}
          />
          <path
            id="Vector_2"
            d="M553.43 409.452H63.7505C63.1374 409.46 62.5249 409.412 61.9207 409.307L293.516 8.15041C294.93 5.65205 296.981 3.57367 299.461 2.12758C301.94 0.68149 304.759 -0.0804749 307.63 -0.0804749C310.5 -0.0804749 313.319 0.68149 315.799 2.12758C318.279 3.57367 320.33 5.65205 321.743 8.15041L477.173 277.358L484.619 290.239L553.43 409.452Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_3"
            opacity="0.2"
            d="M553.43 409.452H386.241L468.314 290.239L474.22 281.652L477.173 277.358L484.619 290.239L553.43 409.452Z"
            fill="black"
          />
          <path
            id="Vector_4"
            d="M826.079 409H402.547L484.619 289.787L490.526 281.199L597.473 125.842C604.485 115.66 621.352 115.026 629.595 123.922C630.149 124.528 630.663 125.17 631.135 125.842L826.079 409Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_5"
            d="M888 407.933H0V410.174H888V407.933Z"
            fill="#3F3D56"
          />
          <g id="Group 1" ref={alien1}>
            <path
              id="leftarm"
              d="M417.725 383.37C434.381 376.918 446.241 367.448 444.215 362.219C442.189 356.991 427.045 357.983 410.389 364.435C393.734 370.888 381.873 380.357 383.899 385.586C385.925 390.815 401.069 389.823 417.725 383.37Z"
              fill="#39FF14"
              ref={leftArm}
            />
            <path
              id="head"
              d="M349.27 447.432C384.994 447.432 413.954 418.472 413.954 382.748C413.954 347.024 384.994 318.064 349.27 318.064C313.546 318.064 284.586 347.024 284.586 382.748C284.586 418.472 313.546 447.432 349.27 447.432Z"
              fill="#39FF14"
            />
            <path
              id="rightleg"
              d="M339.444 433.513H319.794V468.72H339.444V433.513Z"
              fill="#39FF14"
            />
            <path
              id="leftleg"
              d="M378.746 433.513H359.095V468.72H378.746V433.513Z"
              fill="#39FF14"
            />
            <path
              id="rightfoot"
              d="M336.169 475.271C345.213 475.271 352.545 472.521 352.545 469.13C352.545 465.738 345.213 462.989 336.169 462.989C327.125 462.989 319.794 465.738 319.794 469.13C319.794 472.521 327.125 475.271 336.169 475.271Z"
              fill="#39FF14"
            />
            <path
              id="leftfoot"
              d="M375.471 474.452C384.515 474.452 391.846 471.703 391.846 468.311C391.846 464.92 384.515 462.17 375.471 462.17C366.427 462.17 359.095 464.92 359.095 468.311C359.095 471.703 366.427 474.452 375.471 474.452Z"
              fill="#39FF14"
            />
            <path
              id="eyeball"
              d="M350.907 388.48C363.117 388.48 373.014 378.582 373.014 366.373C373.014 354.163 363.117 344.265 350.907 344.265C338.698 344.265 328.8 354.163 328.8 366.373C328.8 378.582 338.698 388.48 350.907 388.48Z"
              fill="white"
            />
            <path
              id="pupil"
              d="M350.907 373.742C354.977 373.742 358.276 370.442 358.276 366.373C358.276 362.303 354.977 359.004 350.907 359.004C346.838 359.004 343.538 362.303 343.538 366.373C343.538 370.442 346.838 373.742 350.907 373.742Z"
              fill="#3F3D56"
              ref={pupil1}
            />
            <path
              id="rightarm"
              d="M291.594 397.914C304.224 385.284 311.248 371.831 307.283 367.865C303.318 363.9 289.865 370.925 277.235 383.555C264.605 396.186 257.58 409.639 261.545 413.604C265.51 417.569 278.963 410.544 291.594 397.914Z"
              fill="#39FF14"
            />
            <path
              id="mouth"
              d="M317.497 406.084C317.497 412.414 333.798 424.916 351.886 424.916C369.974 424.916 386.934 407.092 386.934 400.761C386.934 394.431 369.974 401.99 351.886 401.99C333.798 401.99 317.497 399.753 317.497 406.084Z"
              fill="white"
              ref={mouth1}
            />
          </g>

          <g id="Group 2" ref={alien2}>
            <path
              id="rightarm_2"
              d="M498.101 385.586C500.127 380.357 488.266 370.888 471.611 364.435C454.955 357.983 439.811 356.991 437.785 362.22C435.759 367.448 447.619 376.918 464.275 383.37C480.931 389.823 496.075 390.815 498.101 385.586Z"
              fill="#39FF14"
              ref={rightArm}
            />
            <path
              id="head_2"
              d="M532.73 447.432C568.454 447.432 597.414 418.472 597.414 382.748C597.414 347.024 568.454 318.064 532.73 318.064C497.006 318.064 468.046 347.024 468.046 382.748C468.046 418.472 497.006 447.432 532.73 447.432Z"
              fill="#39FF14"
            />
            <path
              id="leftleg_2"
              d="M542.556 468.72H562.206V433.513H542.556V468.72Z"
              fill="#39FF14"
            />
            <path
              id="rightleg_2"
              d="M503.254 468.72H522.905V433.513H503.254V468.72Z"
              fill="#39FF14"
            />
            <path
              id="leftfoot_2"
              d="M545.831 475.271C554.875 475.271 562.206 472.521 562.206 469.13C562.206 465.738 554.875 462.989 545.831 462.989C536.787 462.989 529.455 465.738 529.455 469.13C529.455 472.521 536.787 475.271 545.831 475.271Z"
              fill="#39FF14"
            />
            <path
              id="rightfoot_2"
              d="M506.529 474.452C515.573 474.452 522.905 471.703 522.905 468.311C522.905 464.92 515.573 462.17 506.529 462.17C497.485 462.17 490.154 464.92 490.154 468.311C490.154 471.703 497.485 474.452 506.529 474.452Z"
              fill="#39FF14"
            />
            <path
              id="eyeball_2"
              d="M531.093 388.48C543.302 388.48 553.2 378.582 553.2 366.373C553.2 354.163 543.302 344.265 531.093 344.265C518.883 344.265 508.986 354.163 508.986 366.373C508.986 378.582 518.883 388.48 531.093 388.48Z"
              fill="white"
            />
            <path
              id="pupil_2"
              d="M531.093 373.742C535.162 373.742 538.462 370.442 538.462 366.373C538.462 362.303 535.162 359.004 531.093 359.004C527.023 359.004 523.724 362.303 523.724 366.373C523.724 370.442 527.023 373.742 531.093 373.742Z"
              fill="#3F3D56"
              ref={pupil2}
            />
            <path
              id="cap"
              d="M595.476 322.594C600.699 299.204 584.003 275.568 558.185 269.803C532.367 264.038 507.203 278.327 501.981 301.718C496.758 325.108 513.868 333.735 539.686 339.5C565.504 345.265 590.253 345.985 595.476 322.594Z"
              fill="#39FF14"
            />
            <path
              id="leftarm_2"
              d="M620.455 413.604C624.42 409.639 617.395 396.186 604.765 383.555C592.135 370.925 578.682 363.9 574.717 367.865C570.752 371.831 577.776 385.284 590.406 397.914C603.037 410.544 616.49 417.569 620.455 413.604Z"
              fill="#39FF14"
            />
            <path
              id="mouth_2"
              d="M564.503 406.084C564.503 412.414 548.202 424.916 530.114 424.916C512.026 424.916 495.066 407.092 495.066 400.761C495.066 394.431 512.026 401.99 530.114 401.99C548.202 401.99 564.503 399.753 564.503 406.084Z"
              fill="white"
              ref={mouth2}
            />
          </g>
          <path
            id="Vector_6"
            d="M888 314.863C888 356.664 863.15 371.259 832.496 371.259C801.842 371.259 776.991 356.664 776.991 314.863C776.991 273.061 832.496 219.884 832.496 219.884C832.496 219.884 888 273.061 888 314.863Z"
            fill="#39FF14"
          />
          <path
            id="Vector_7"
            d="M830.474 364.865L831.042 329.881L854.699 286.601L831.131 324.393L831.387 308.663L847.691 277.35L831.454 304.5L831.914 276.209L849.373 251.28L831.986 271.76L832.273 219.884L830.469 288.559L830.617 285.726L812.866 258.555L830.332 291.164L828.678 322.761L828.629 321.922L808.166 293.329L828.567 324.885L828.36 328.836L828.323 328.896L828.34 329.22L824.144 409.383H829.751L830.423 367.977L850.775 336.499L830.474 364.865Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="888" height="475.271" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export default TrueLove;
